export const homePathForVersions = {
  WEB_USER: '/',
  CONTRACTOR_USER: '/',
  payerPortal: '/',
  memberPortal: '/',
};

export const CONTRACTOR_USER = 'CONTRACTOR_USER';
export const WEB_USER = 'WEB_USER';
export const MOBILE_USER = 'MOBILE_USER';
